<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { canAccessContent } from "@/utils/content-access";

export default {
  locales: {
    pt: {
      'Downloads': 'Downloads',
    },
    es: {
      'Downloads': 'Descargas',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      folders: null,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    getList() {
      api
        .get('downloads')
        .then((response) => {
          if (response.data.status == 'success') {
            const user = this.account.user;
            const folders = {};
            Object.keys(response.data.folders).forEach((key) => {
              const folder = response.data.folders[key];
              if (canAccessContent(folder.requires, user)) {
                folders[key] = folder;
              }
            });
            this.folders = folders
          }
        })
    }
  },
  mounted() {
    this.getList()
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('Downloads') }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!folders" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else>
      <div v-for="(downloads, index) in folders" :key="index">
        <div v-if="downloads.list.length > 0" class="card">
          <div class="card-header rounded bg-default m-1" v-b-toggle="'files_' + index">
            <h5 class="mb-0 text-white">{{ downloads.name }}</h5>
          </div>
          <b-collapse :id="'files_' + index" class="card-body">
            <div class="card-files row">
              <div class="card-file col-md-3 text-center" v-for="(row, index) in downloads.list" :key="index">
                <img v-if="row.file.cover" class="file-cover" :src="row.file.cover" />
                <h5 class="mb-3 font-size-18">{{ row.title }}</h5>
                <a target="_blank" class="btn btn-outline-default btn-block" :href="row.file.url">Download</a>
                <div class="d-flex justify-content-center mt-2">
                  <div class="flex-fill font-size-12 text-uppercase px-1">
                    {{ row.file.type }}<br>
                    <span class="bg-soft-default rounded font-size-11 px-1">FORMATO</span>
                  </div>
                  <div class="flex-fill font-size-12 px-1">
                    {{ (row.file.size / 1024).toFixed(2) }} MB<br>
                    <span class="bg-soft-default rounded font-size-11 px-1">TAMANHO</span>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.file-cover {
  border-radius: 5px;
  margin-bottom: 10px;
  width: 100%;
  object-fit: cover;
  aspect-ratio: 10 / 5;
}
@media (max-width: 500px) {
  .card-file {
    margin-bottom: 25px;
  }
}
</style>
